import "./DaPageWrapper.css";
import { useId } from "react";
import PropTypes from "prop-types";
import { DaShell } from "../DaShell/DaShell";
import { DaIcon } from "../DaIcon/DaIcon";

const DaPageWrapper = ({ wrapperClass = "da-page-wrapper", iconType, title, subtitle, children }) => {
  const base = wrapperClass.split(" ")[0] || "da-page-wrapper";
  const subtitleId = useId();

  return (
    <DaShell>
      <main className={wrapperClass}>
        {iconType && (
          <div className={`${base}-icon`} aria-hidden="true">
            <DaIcon type={iconType} />
          </div>
        )}

        {title && (
          <h1 className={`${base}-title`} {...(subtitle ? { "aria-describedby": subtitleId } : {})}>
            {title}
          </h1>
        )}

        {subtitle && (
          <p id={subtitleId} className={`${base}-subtitle`}>
            {subtitle}
          </p>
        )}

        {children}
      </main>
    </DaShell>
  );
};

DaPageWrapper.propTypes = {
  wrapperClass: PropTypes.string,
  iconType: PropTypes.string,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node,
};

export default DaPageWrapper;
